import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-g1000-prototype-page',
  templateUrl: './g1000-prototype-page.component.html',
  styleUrls: ['./g1000-prototype-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class G1000PrototypePageComponent { }
